import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=0842e286"
import script from "./OrgInfo.vue?vue&type=script&lang=js"
export * from "./OrgInfo.vue?vue&type=script&lang=js"
import style0 from "./OrgInfo.vue?vue&type=style&index=0&id=0842e286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports